import clsx from 'clsx';

type NonTranslatableTextProps = {
	children: React.ReactNode;
	className?: string;
};

export function NonTranslatableText({ children, className }: NonTranslatableTextProps) {
	return (
		<span
			translate='no'
			className={clsx('notranslate', className)}
		>
			{children}
		</span>
	);
}
